import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
import { resolveRuntimeEnvironment } from '../../../utils/runtimeEnvironment';

const DEFAULT_OIDC_SCOPE = 'openid profile email offline_access';

export function resolveOidcScope(configured: string | undefined): string {
  return resolveRuntimeEnvironment(configured, DEFAULT_OIDC_SCOPE);
}

export const oidcAuthConfig: UserManagerSettings = {
  authority: import.meta.env.VITE_OIDC_ISSUER,
  client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_OIDC_REDIRECT_URI,
  post_logout_redirect_uri: import.meta.env.VITE_OIDC_SIGNOUT_URI,
  response_type: 'code',
  // Overridable so an IdP that only allows a narrower scope set (e.g. the Cognito UI client's
  // 'openid email') can request just those; defaults to the full set for IdPs that support it.
  scope: resolveOidcScope(import.meta.env.VITE_OIDC_SCOPE),
  monitorSession: false,
  automaticSilentRenew: true,
  silent_redirect_uri: import.meta.env.VITE_OIDC_REDIRECT_URI,
  userStore: new WebStorageStateStore({ store: globalThis.localStorage }),
};
